import { colors, variables } from '@resurs/midas'

export default {
  filterOptions: {
    display: 'flex',
    flex: '1 1 100%',
    paddingBottom: '10px',
  },
  avatar: {
    background: '#000',
    borderRadius: '50%',
    display: 'inline-block',
    height: '1.8rem',
    width: '1.8rem',
    lineHeight: '1',
    margin: '0',
    verticalAlign: 'middle',
  },
  tableData: {
    padding: '0rem 1rem',
  },
  creditBadge: {
    display: 'inline-block',
    color: colors.red2,
    textAlign: 'center',
    paddingTop: '0.3rem',
    verticalAlign: 'middle',
  },
  debitBadge: {
    display: 'inline-block',
    color: colors.green1,
    textAlign: 'center',
    paddingTop: '0.3rem',
    verticalAlign: 'middle',
  },
  annulBadge: {
    display: 'inline-block',
    color: colors.orange2,
    textAlign: 'center',
    paddingTop: '0.3rem',
    verticalAlign: 'middle',
  },
  center: {
    textAlign: 'center',
  },
  badgeLabel: {
    paddingLeft: '1rem',
    lineHeight: '1.6',
  },
  tableHead: {
    verticalAlign: 'bottom',
    fontSize: '80%',
  },
  tableNumber: {
    textAlign: 'right',
    paddingRight: '2rem',
  },
  tableDate: {
    textAlign: 'right',
    paddingRight: '2rem',
  },
  tableIcon: {
    textAlign: 'center',
  },
  inputContainer: {
    margin: 'auto',
    display: 'inline-block',
  },
  inputPosition: {
    marginTop: '-1rem',
    maxWidth: '6rem',
  },
  inputPositionAmount: {
    marginTop: '-1rem',
    maxWidth: '10rem',
  },
  textStrong: {
    lineHeight: '2.5rem',
    fontWeight: '600',
    textTransform: 'uppercase',
  },
  infobox: {
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
    flexGrow: 1,
  },

  // transactionDetailsUI: orderinformation
  info: {
    borderRight: '1px solid #eee',
    borderBottom: '1px solid #eee',
    flex: 'auto',
    padding: '.5rem 1rem',
    marginRight: '-1px',
    height: '100%',
  },
  noBorder: {
    border: 0,
  },
  borderLeft: {
    borderLeft: '1px solid #eee',
  },
  noBorderBottom: {
    borderBottom: 0,
  },
  noPaddingLeft: {
    paddingLeft: '0rem',
  },
  label: {
    paddingTop: '0.7rem',
    fontWeight: 'bold',
    marginLeft: '1rem',
  },
  name: {
    lineHeight: '3.5rem',
    margin: '0 0 0 1rem',
    paddingTop: '1rem',
    fontWeight: 'normal',
    color: colors.error7,
  },
  grayNameLabel: {
    color: '#777',
  },
  value: {
    fontFamily: variables.headerFontFamily,
    fontSize: '1.7rem',
    margin: '.5rem 0',
    marginLeft: '1rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  flexRowSpaceBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  icon: {
    display: 'flex',
    alignContent: 'center',
  },
}
